import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceListComponent } from './device-list/device-list.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  isFullscreenRoute = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
    // Überprüfen der aktuellen Route bei Navigation
    this.router.events.subscribe(() => {
      this.isFullscreenRoute = this.router.url === '/fullscreen-devices';
    });
  }
}
